import { ICategory } from "./PackageFeatures.types";

const tlmPackages: ICategory[] = [
    {
        categoryId: 'inventory',
        category_name: "Inventory",
        features: [
            {
                featureId: "ftr_em_cloud_scanner",
                feature_name: "Network Discovery - cloud scanner (public IPs)",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_network_discovery",
                feature_name: "Network Discovery - sensor (public/private)",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_system_scan",
                feature_name: "System Scans - agent",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_3rdparty_scans",
                feature_name: "3rd party scans",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_cloud_services_account",
                feature_name: "Cloud services - Account/project level",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_connector_cloud_services_org",
                feature_name: "Cloud services - Org level",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_auto_cert_mgmt",
                feature_name: "Imports via CSV",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_pki8_connector_configuration",
                feature_name: "Imports from CAs",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_service_now_cmdb_integration",
                feature_name: "CMDB",
                essential: false,
                advanced: false,
                premium: true
            }
        ]
    },
    {
        categoryId: 'management',
        category_name: "Management",
        features: [
            {
                featureId: "ftr_em_rest_ui",
                feature_name: "Enroll/Renew via UI",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_rest_api",
                feature_name: "Enroll/Renew via APIs",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_open",
                feature_name: "Self service portal - open",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_authenticated",
                feature_name: "Self service portal - authenticated",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_self_service_portal_branding",
                feature_name: "Self service portal - branding",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_acme_scep",
                feature_name: "ACME, SCEP",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_est_aes",
                feature_name: "EST, AES",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_cmp_cmc",
                feature_name: "CMP",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_digicert_trust_assistant",
                feature_name: "Integrations via agent, sensor, DTA",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_intune",
                feature_name: "Intune",
                essential: false,
                advanced: false,
                premium: true
            }
        ]
    },
    {
        categoryId: 'ca',
        category_name: "CAs",
        features: [
            {
                featureId: "ftr_em_cert_central_duplicate_certs",
                feature_name: "CertCentral, Private PKI",
                essential: false,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_step_ca",
                feature_name: "Other CAs",
                essential: false,
                advanced: false,
                premium: true
            },
            {
                featureId: "ftr_em_digicert_on_prem_ca",
                feature_name: "DigiCert On-prem CA",
                essential: false,
                advanced: false,
                premium: true
            }
        ]
    },
    {
        categoryId: 'other',
        category_name: "Other",
        features: [
            {
                featureId: "ftr_em_custom_reporting",
                feature_name: "Custom reports",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_over_consumption",
                feature_name: "Over consumption",
                essential: true,
                advanced: true,
                premium: true
            },
            {
                featureId: "ftr_em_ldap_search",
                feature_name: "LDAP Search",
                essential: true,
                advanced: true,
                premium: true
            }
        ]
    }
];

const packageTypes = [
    {
        package_name: "essential",
        package_id: "pkg_essential",
        active: false,
        canUpgradeTo: ["pkg_advanced", "pkg_premium"],

    },
    {
        package_name: "advanced",
        package_id: "pkg_advanced",
        active: false,
        canUpgradeTo: ["pkg_premium"],
    },
    {
        package_name: "premium",
        package_id: "pkg_premium",
        active: false,
        canUpgradeTo: [],
    }
]

export { tlmPackages, packageTypes };
